module.exports = __webpack_public_path__ + "static/mark_main_profile-89c65cf0d500f1baf3fa62187c4741a9.png";